import { render, staticRenderFns } from "./c-foot.vue?vue&type=template&id=4f12a993&scoped=true&"
import script from "./c-foot.vue?vue&type=script&lang=js&"
export * from "./c-foot.vue?vue&type=script&lang=js&"
import style0 from "./c-foot.vue?vue&type=style&index=0&id=4f12a993&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12a993",
  null
  
)

export default component.exports